import React from 'react';
import StylesType from '@/types/StylesType';
import { Row, Col } from 'antd';
import { Icon } from '@/components';

import './style/index';

export interface PhoneModalProps extends StylesType {
    sizeType: string;
    sizeTypeChange: (type: string) => void;

    rotateType: string;
    rotateTypeChange: () => void;

    setList: string;
    setListChange: () => void;

    closeMask: () => void;
    coludStatus: string;
    masterId: string;
    mask: string;
    actions: any;
}


export const PhoneModal: React.FC<PhoneModalProps> = props => {

    const { coludStatus, prefixCls, rotateType, sizeType, masterId, mask, actions, rotateTypeChange, sizeTypeChange, closeMask, setList, setListChange } = props;
    const classNameModal = `${prefixCls}-${rotateType}-${sizeType}`;
    
    

    return (
        <Row id='phoneModal' className={`${prefixCls} ${prefixCls}-${mask}`}>
            <Row style={{ height: '100vh' }} type='flex' justify='center' align="middle">
                <Col>
                    <Row className={`${classNameModal}-top`}>
                        <Col className={`${classNameModal}-top-name`}>CID：{masterId}</Col>
                    </Row>
                    <Row>
                        <Row className={`${classNameModal}-play-out`}>
                            <Row className={`${classNameModal}-${coludStatus}`}>
                                <Icon type={'iconshuaxin'} className={`${classNameModal}-${coludStatus}-icon`} />
                                加载中...
                            </Row>
                            <Col className={`${classNameModal}-play`} id={masterId}>

                            </Col>
                        </Row>
                    </Row>
                    <Row className={`${classNameModal}-bottom`} type='flex' justify='space-between'>
                        <Col onClick={() => actions.backspace(masterId)} className={`${classNameModal}-bottom-icon`} span={6}><Icon type={'iconback'} /></Col>
                        <Col onClick={() => actions.home(masterId)} className={`${classNameModal}-bottom-icon`} span={6}><Icon type={'iconhome'} /></Col>
                        <Col onClick={() => actions.menu(masterId)} className={`${classNameModal}-bottom-icon`} span={6}><Icon type={'iconsider'} /></Col>
                        <Col onClick={rotateTypeChange} className={`${classNameModal}-bottom-icon`} span={6}><Icon type={'iconroate'} /></Col>
                    </Row>
                </Col>
                <Col className={`${classNameModal}-set`}>
                    <Col onClick={closeMask} className={`${classNameModal}-set-close`}><Icon type={'iconclose'} /></Col>
                    <Col onClick={() => actions.volumeUp(masterId)} className={`${classNameModal}-set-sound-up`}><Icon type={'iconvolum'} /></Col>
                    <Col onClick={() => actions.volumeDown(masterId)} className={`${classNameModal}-set-sound-down`}><Icon type={'iconvolum-'} /></Col>
                    <Col onClick={setListChange} className={`${classNameModal}-set-size`}>
                        <Icon type={sizeType === 'small' ? 'iconscale2' : sizeType === 'medium' ? 'iconscale' : 'iconscale1'} />
                        <Icon className={`${classNameModal}-set-show`} type={'iconshushouqi'} />
                    </Col>
                    <Col className={`${classNameModal}-set-size-list ${classNameModal}-set-size-list-${setList}`}>
                        <span onClick={() => sizeTypeChange('small')} className={`${classNameModal}-set-size-list-item`}>×1.0</span>
                        <span onClick={() => sizeTypeChange('medium')} className={`${classNameModal}-set-size-list-item`}>×1.5</span>
                        <span onClick={() => sizeTypeChange('big')} className={`${classNameModal}-set-size-list-item`}>×2.0</span>
                    </Col>
                </Col>
            </Row>
        </Row>
    )

}

PhoneModal.defaultProps = {
    prefixCls: 'gc-phoneModal'
}


export default PhoneModal;
